import { Text } from "@/components/ui/text";
import { cn } from "@/lib/utils";
import { View } from "react-native";

function Card({
    className,
    ...props
}: React.ComponentProps<typeof View> & React.RefAttributes<View>) {
    return (
        <View
            className={cn(
                "bg-card border border-border flex flex-col gap-6 rounded-xl py-6 shadow-sm shadow-black/5",
                className,
            )}
            {...props}
        />
    );
}

function CardHeader({
    className,
    ...props
}: React.ComponentProps<typeof View> & React.RefAttributes<View>) {
    return (
        <View
            className={cn("flex flex-col gap-1.5 px-6", className)}
            {...props}
        />
    );
}

function CardTitle({
    className,
    ref,
    ...props
}: React.ComponentProps<typeof Text> & React.RefAttributes<typeof Text>) {
    return (
        <Text
            ref={ref}
            role="heading"
            aria-level={3}
            className={cn("font-semibold leading-none", className)}
            {...props}
        />
    );
}

function CardDescription({
    className,
    ...props
}: React.ComponentProps<typeof Text> & React.RefAttributes<typeof Text>) {
    return (
        <Text
            className={cn("text-muted-foreground text-sm", className)}
            {...props}
        />
    );
}

function CardContent({
    className,
    ...props
}: React.ComponentProps<typeof View> & React.RefAttributes<View>) {
    return <View className={cn("px-6", className)} {...props} />;
}

function CardFooter({
    className,
    ...props
}: React.ComponentProps<typeof View> & React.RefAttributes<View>) {
    return (
        <View
            className={cn("flex flex-row items-center px-6", className)}
            {...props}
        />
    );
}

export {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle
};

